module.exports = __webpack_public_path__ + "static/img/block-2.143544eb.png";